module.exports = __webpack_public_path__ + "static/media/right-arrow.2f4cedc8.svg";